module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/237.0b4e1cc6.png";